import React from 'react';
import { Button, ThemeProvider } from '@mui/material';
import { theme } from '../../../styles/theme';
import { Icons, Size } from '../../../../types/union.type';
import { IconLabelSize } from '../../../../config/size';

interface Props {
  children?: React.ReactNode;
  variant?: 'text' | 'outlined' | 'contained';
  color?: 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
  size?: Size;
  padding?: string;
  icon?: Icons;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  onClick?: () => void;
  onSubmit?: () => void;
  disabled?: boolean;
  href?: string;
}

export const CustomButton: React.FC<Props> = ({
  children,
  variant = 'contained',
  color = 'primary',
  padding = '8px 16px',
  size = 'small',
  className,
  onClick,
  onSubmit,
  type,
  disabled,
  href
}) => {
  return (
    <ThemeProvider theme={theme}>
      <Button
        disabled={disabled}
        className={className}
        style={{
          borderRadius: '30px',
          padding: padding,
          boxShadow: 'none',
        }}
        variant={variant}
        color={color}
        onClick={onClick}
        onSubmit={onSubmit}
        type={type}
        href={href}
      >
        <div
          style={{
            fontSize: IconLabelSize[size]['fontSize'],
            color:
              variant === 'contained' ? '#fff' : theme.palette[color]['main'],
          }}
        >
          {children}
        </div>
      </Button>
    </ThemeProvider>
  );
};
